import React, { useState, useEffect, useRef } from "react";
import Tab1Image from "../img/envision/aerospace/tabsimages/traficaerospace.jpg";
import Tab2Image from "../img/envision/aerospace/tabsimages/cybersecurityaero.jpg";
import Tab3Image from "../img/envision/aerospace/tabsimages/ceaaero.jpg";
import Tab4Image from "../img/envision/aerospace/tabsimages/aerocyber1.jpg";
import Tab5Image from "../img/envision/aerospace/tabsimages/[freepicdownloader.com]-generative-ai-military-fighter-jets-patrol-air-launch-missiles-medium.jpg";
import Tab6Image from "../img/envision/aerospace/tabsimages/animatedaerospace.jpg";
import Tab7Image from "../img/envision/aerospace/tabsimages/jhkk.jpg";
import Tab8Image from "../img/envision/aerospace/tabsimages/futuristic-time-machine.jpg";
import Tab9Image from "../img/envision/aerospace/tabsimages/space-travel-collage-design.jpg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const AeroVerticalTabss = () => {
  const firstContentRef = useRef(null);
  const [activeTab, setActiveTab] = useState("tab1");
  const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay

  const tabContainerRef = useRef(null);
  // const handleTabClick = (tabId) => {
  //   setActiveTab(tabId);
  // };
  const handleKnowMoreFirstClick = () => {
    navigate("/documentaerospacepage#AerospaceDocumentDatatabs");
  };

  const navigate = useNavigate(); // Initialize navigate

  // const handleKnowMoreClick = () => {
  //   navigate("/documentaerospacepage#AerospaceDocumentDatatabs");
  // };

  const handleKnowMoreClick = (tabId) => {
    navigate(`/documentaerospacepage?activeTab=${tabId}`);

    setTimeout(() => {
      const targetElement = document.getElementById("AerospaceDocumentDatatabs");
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 300); // Delay ensures navigation occurs first
  };

  const [isHovered, setIsHovered] = useState(false);

  // Autoplay effect to change tabs every 3 seconds (3000ms)
  useEffect(() => {
    let tabInterval;

    if (!isHovered && isAutoPlayActive) {
      tabInterval = setInterval(() => {
        setActiveTab((prevTab) => {
          const nextTabNum = parseInt(prevTab.replace("tab", "")) % 8 + 1;
          return `tab${nextTabNum}`;
        });
      }, 3000);
    }

    return () => clearInterval(tabInterval);
  }, [activeTab, isHovered, isAutoPlayActive]);


  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
  };

  // Scroll the active tab button into view inside tabNav

  // Auto-scroll active tab into view inside the tab container
  useEffect(() => {
    if (tabContainerRef.current) {
      const container = tabContainerRef.current;
      const activeTabElement = document.getElementById(activeTab);

      if (activeTabElement) {
        // Get the position of the active tab within the container
        const activeTabOffsetTop = activeTabElement.offsetTop;

        // Smoothly scroll the container to that position
        container.scrollTo({
          top: activeTabOffsetTop - container.offsetTop, // Adjust based on the container's offset
          behavior: 'smooth', // Smooth scroll
        });
      }
    }
  }, [activeTab]);

  const styles = {
    container: {
      fontFamily: '"Helvetica Neue", Arial, sans-serif',
      width: "80%",
      margin: "50px auto",
      overflowY: "auto", // Allow scrolling within the container
      maxHeight: "500px", // Limit the height of the tab container (or set your preferred value)
      scrollBehavior: "smooth", // Enable smooth scrolling only within the container


    },
    tabNav: {

      flexDirection: "column",
      borderRight: "1px solid #fff",
      height: "350px",
      overflowY: "auto", // Ensure only vertical scrolling
      scrollbarWidth: "thin", // For Firefox
      scrollbarColor: "#ccc transparent", // For Firefox
      direction: "rtl", // This makes the scrollbar appear on the left side
      scrollBehavior: "smooth",
    },

    tabButton: {
      padding: "15px",
      cursor: "pointer",
      border: "none",
      background: "none",
      fontSize: "16px",
      fontWeight: "bold",
      color: "#555",
      outline: "none",
      transition: "color 0.3s, background-color 0.3s",
      borderRadius: "10px",
      margin: "5px 0",
      backgroundColor: "#f0f0f0",
    },
    activeTabButton: {
      backgroundColor: "rgb(236 115 34)",
      color: "#fff",
    },
    card: {
      // display: "flex",
      alignItems: "center",
      padding: "20px",
      borderRadius: "15px",
      backgroundColor: "#fff",
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
      width: "100%",
      // marginLeft: "10px",
      cursor: "pointer",
      height: "350px",
      overflowY: "auto"

    },
    image: {
      width: "382px",
      height: "274px",
      borderRadius: "10px",
      marginRight: "20px",
      // marginTop: "50px"
    },
    textContent: {
      flex: 1,
      textAlign: "justify !important",
      color: "#333",
      fontFamily: '"Helvetica Neue", Arial, sans-serif',
      height:"1200px"
    },
    icon: {
      marginRight: "10px",
      fontSize: "24px",
      color: "#009ca5",
    },
    dotNav: {
      display: "flex",
      justifyContent: "center",
      marginTop: "10px",
    },
    dot: {
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: "#ccc",
      margin: "0 5px",
      cursor: "pointer",
      transition: "background-color 0.3s",
    },
    activeDot: {
      backgroundColor: "rgb(236 115 34)",
    },
    knowMoreButton: {
      marginTop: "15px",
      padding: "10px 20px",
      backgroundColor: "rgb(236 115 34)",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "background-color 0.3s",
      // marginLeft: "150px"
    },
    knowMoreButtonHover: {
      backgroundColor: "rgb(236 115 34)",
    },
    tabdata: {
      overflowx: "auto",
      whiteSpace: "nowrap"

    }


  };

  return (
    <div>
      <h1 style={{ textAlign: "center" }}>
        <span style={{ color: "rgb(236 115 34)" }}>Regulatory Compliance</span> Services
      </h1>
      <div style={styles.container}
        className="tabclass-container-data"
      >



        <div
          style={{
            ...styles.tabNav,
            overflowY: 'auto', // Allow scrolling within the container
            scrollBehavior: 'smooth', // Enable smooth scrolling within the container
          }}
          ref={tabContainerRef}
          className="tabdata"
        >
          {[
            'ITAR (International Traffic in Arms Regulations)',
            'Cybersecurity Maturity Model Certification (CMMC)',
            'ICAO Cybersecurity Guidelines',
            'EU GDPR (General Data Protection Regulation)',
            'SWIFT Customer Security Controls Framework (CSCF)',
            'DO-326A (Airworthiness Security Process for Aircraft Systems)',
            'Industrial Control Systems (ICS) Security Guidelines',
            'ISO/SAE 21434 (Cybersecurity for Automotive/Aerospace Systems)',
          ].map((tab, index) => {
            const tabId = `tab${index + 1}`;
            return (
              <button
                key={tabId}
                id={tabId}
                style={{
                  ...styles.tabButton,
                  ...(activeTab === tabId
                    ? { ...styles.activeTabButton, backgroundColor: 'rgb(236 115 34)', color: '#fff' }
                    : {}),
                }}
                onClick={() => handleTabClick(tabId)}
                className="tab-button-width"
                onMouseEnter={(e) => {
                  if (activeTab !== tabId) {
                    e.currentTarget.style.backgroundColor = '#000'; // Change background to black on hover
                    e.currentTarget.style.color = '#fff'; // Change text to white on hover
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== tabId) {
                    e.currentTarget.style.backgroundColor = ''; // Revert background on mouse leave
                    e.currentTarget.style.color = ''; // Revert text color on mouse leave
                  }
                }}
              >
                {tab} compliance
              </button>
            );
          })}
        </div>



        <div
          style={styles.card}
          className="card-data-vertica-tabs"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <img
            src={{
              tab1: Tab1Image,
              tab2: Tab2Image,
              tab3: Tab3Image,
              tab4: Tab4Image,
              tab5: Tab5Image,
              tab6: Tab6Image,
              tab7: Tab7Image,
              tab8: Tab8Image,
              tab9: Tab9Image,
            }[activeTab]}
            alt="Healthcare"
            style={styles.image}
            className="tab-image-data"
          />

          <div style={styles.textContent}>
            {[
              {
              
                content:
                  "The International Traffic in Arms Regulations (ITAR) is a U.S. regulatory framework ensuring that defence-related articles, services, and technical data are securely controlled to prevent unauthorized access. ITAR compliance is crucial for organizations involved in manufacturing, exporting, or handling military and defence-related products, including aerospace, defence contracting, and dual-use technologies. \n  ITAR mandates strict export controls, licensing requirements, and access restrictions to safeguard U.S. military technologies from unauthorized foreign entities. Companies must register with the U.S. Department of State’s Directorate of Defence Trade Controls (DDTC) and implement robust security measures to protect controlled technical data from cyber threats, unauthorized disclosures, and foreign influence. \n  Regular audits and inspections by DDTC, U.S. Customs, and compliance officers ensure adherence to ITAR requirements. Non-compliance can result in severe penalties, export bans, criminal charges, and reputational damage, reinforcing the importance of maintaining stringent access controls, proper documentation, and continuous monitoring of all defence-related transactions ",
              },
              {
      
                content:
                  "The Cybersecurity Maturity Model Certification (CMMC) is a U.S. Department of Defence (DoD) framework designed to enhance cybersecurity protections for defence contractors handling Federal Contract Information (FCI) and Controlled Unclassified Information (CUI). It applies to aerospace, defence, and supply chain companies working with the DoD to prevent cyber threats and safeguard national security. \n CMMC establishes a tiered cybersecurity maturity model (Level 1 to Level 3) with progressive security requirements, including access control, incident response, security assessments, and data encryption. Organizations must meet specific cybersecurity standards based on their contract sensitivity and undergo third-party assessments to verify compliance before securing defence contracts. \n Regular audits by Certified Third-Party Assessment Organizations (C3PAOs) and compliance reviews by the Cyber Accreditation Body (Cyber AB) ensure that defence contractors maintain strict cybersecurity postures. Non-compliance can lead to loss of DoD contracts, security breaches, and regulatory penalties, emphasizing the need for continuous security enhancements and risk management strategies in the aerospace and defence sectors.",
              },
              {
         
                content:
                  "The International Civil Aviation Organization (ICAO) Cybersecurity Guidelines establish a global framework for securing aviation infrastructure, protecting critical data, and mitigating cyber threats in the civil aviation and aerospace industries. These guidelines help airlines, airports, air navigation service providers (ANSPs), and aerospace manufacturers ensure safe and resilient aviation operations against cyber risks. \n ICAO’s cybersecurity framework mandates risk-based security measures, information sharing, and cybersecurity governance for aviation stakeholders. Compliance requires implementation of robust cybersecurity policies, secure data communication protocols, network protection mechanisms, and real-time threat monitoring. Organizations must align with ICAO Annex 17 (Security), Annex 19 (Safety Management Systems), and the Aviation Cybersecurity Strategy (2020–2030). \n Regular cybersecurity audits, penetration testing, and compliance assessments are conducted by national civil aviation authorities (CAAs) and international regulatory bodies to ensure adherence. Non-compliance can result in regulatory actions, increased cyber vulnerabilities, flight disruptions, and reputational damage, making continuous cyber risk management, incident response planning, and collaboration with global aviation security agencies essential for cybersecurity resilience in civil aviation.",
              },
              {
          
                content:
                  "The EU General Data Protection Regulation (GDPR) enforces strict data privacy and security measures for aerospace and defense organizations handling personally identifiable information (PII) in defense contracts, supply chains, and cross-border collaborations. \n Compliance requires data encryption, access controls, consent management, and Data Protection Impact Assessments (DPIAs) for sensitive data. Organizations must implement privacy-by-design, secure international data transfers, and incident response plans to prevent breaches.\n Regular audits by EU Data Protection Authorities (DPAs) ensure adherence, with non-compliance leading to fines up to €20 million or 4% of global revenue. Aerospace and defence firms must adopt cyber resilience strategies and strong data governance to protect critical infrastructure and maintain regulatory integrity.",
              },
              {
               
                content:
                  "The SWIFT Customer Security Controls Framework (CSCF) is a global cybersecurity standard designed to secure financial transactions and prevent cyber fraud across banks, financial institutions, and SWIFT network users. It mandates strict security controls to protect SWIFT-connected systems from cyber threats. \n Compliance requires multi-factor authentication (MFA), endpoint security, access controls, secure network segmentation, and real-time threat monitoring. Organizations must implement risk-based security measures, incident response plans, and regular security testing to safeguard financial messaging operations. \n Regular independent audits and security attestations ensure adherence, with non-compliance leading to increased fraud risks, regulatory penalties, and reputational damage. To maintain SWIFT compliance, financial institutions must continuously enhance cybersecurity resilience, monitor evolving threats, and align with global banking security regulations.",
              },
              {
                
                content:
                  "The DO-326A standard, developed by RTCA and EUROCAE, establishes a cybersecurity framework for aircraft systems, ensuring airworthiness and protection against cyber threats. It applies to aircraft manufacturers, avionics suppliers, and maintenance organizations, addressing security risks in aviation systems, software, and communication networks. \n Compliance requires threat identification, risk assessment, security architecture development, and continuous monitoring throughout the aircraft lifecycle. Organizations must implement secure software development, network protection, and incident response plans to mitigate cyber vulnerabilities in onboard and connected systems. \n Regular compliance audits, penetration testing, and regulatory reviews by aviation authorities (FAA, EASA, and ICAO) ensure adherence. Non-compliance can result in certification delays, operational risks, and regulatory penalties, making DO-326A a critical standard for maintaining aviation cybersecurity and flight safety.",
              },
              {
     
                content:
                  "ICS security guidelines protect critical infrastructure, manufacturing, energy, aerospace, and defence from cyber threats targeting SCADA, DCS, and IIoT systems. \n Compliance requires network segmentation, MFA, encryption, access control, monitoring, and incident response to secure Operational Technology (OT). Organizations must conduct risk assessments, patch management, and threat intelligence integration to prevent cyberattacks. \n Regular audits by NIST (SP 800-82), IEC 62443, CISA (U.S.), and CERT-In (India) ensure adherence. Non-compliance can lead to downtime, penalties, and cyber risks, making ICS security critical for resilient operations .",
              },
              {
              
                content:
                  "The ISO/SAE 21434 standard establishes a cybersecurity framework for automotive and aerospace electronic systems, ensuring protection against cyber threats throughout the vehicle and aircraft lifecycle. It applies to OEMs, Tier-1 & Tier-2 suppliers, avionics manufacturers, and cybersecurity service providers. \n Compliance mandates risk assessment, threat analysis, secure software development, encryption, penetration testing, and incident response to safeguard connected and autonomous vehicle/aircraft systems. Organizations must implement continuous monitoring, secure over-the-air (OTA) updates, and vulnerability management to mitigate cyber risks. \n Regular compliance audits, cybersecurity testing, and regulatory assessments ensure adherence. Non-compliance can lead to security breaches, regulatory fines, and operational failures, making ISO/SAE 21434 essential for securing modern transportation systems against cyber threats.",
              },
            ].map((tabContent, index) => (
              <div
                key={index}
                style={{
                  display: activeTab === `tab${index + 1}` ? "block" : "none",
                  textAlign: "justify",
                  whiteSpace: "pre-line",
                  fontFamily: '"Helvetica Neue", Arial, sans-serif',
                  height: "auto",
                }}
                className={`aerotabonedata tab${index + 1}-larges-screen-margin`}
              >
                <p style={{textAlign:"justify"}}>{tabContent.content}</p>
                <button
                  onClick={() => handleKnowMoreClick(`tab${index + 1}`)}
                  style={{
                    ...styles.knowMoreButton,
                    ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}),
                    alignSelf: "center",
                  }}
                  className="know-more-btn"
                >
                  Know More
                </button>
              </div>
            ))}
          </div>




        </div>


      </div>

      {/* Dot Navigation */}
      <div style={styles.dotNav}>
        {[...Array(8)].map((_, index) => {
          const tab = `tab${index + 1}`;
          return (
            <div
              key={tab}
              style={{
                ...styles.dot,
                ...(activeTab === tab ? styles.activeDot : {}),
              }}
              onClick={() => handleTabClick(tab)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AeroVerticalTabss;
